export const QUERY_KEYS = {
  // Existing keys
  MAU_SO_HOA_DON: 'contract-number-formats',
  HISTORY: 'history',
  // Location related
  QUOC_GIA: 'countries',
  TINH_THANH: 'provinces',
  QUAN_HUYEN: 'districts',
  XA_PHUONG: 'wards',
  KHU_VUC: 'regions',

  // Payment related
  PHUONG_THUC_THANH_TOAN: 'payment-methods',
  PHUONG_THUC_GIAO_HANG: 'delivery-methods',
  HAN_THANH_TOAN: 'payment-terms',
  HINH_THUC_THANH_TOAN: 'danh-muc/ban-hang/hinh-thuc-thanh-toan',
  TIEN_DO_THANH_TOAN: 'payment-schedules',
  DOT_THANH_TOAN: 'danh-muc/hop-dong-khe-uoc/dot-thanh-toan',
  DIEU_KIEN_THANH_TOAN: 'payment-conditions',
  CHI_TIET_DIEU_KIEN_THANH_TOAN: 'payment-condition-details',

  // Product attributes
  KICH_CO: 'sizes',
  MAU_SAC: 'colors',
  QUY_CACH: 'specifications',

  // Tax related
  THUE: 'danh-muc/thue/danh-muc-thue-suat',
  NHOM_THUE: 'tax-groups',
  TINH_CHAT_THUE: 'tax-natures',
  CO_QUAN_THUE: 'tax-authorities',
  BANG_KE_HOA_DON_CHUNG_TU_HANG_HOA_DICH_VU_MUA_VAO:
    'thue/bang-ke-thue/bang-ke-hoa-don-chung-tu-hang-hoa-dich-vu-mua-vao',

  // Document related
  QUYEN_CHUNG_TU: 'document-books',
  MAU_HOA_DON: 'invoice-templates',
  CHUNG_TU: 'documents',
  LOAI_HOA_DON: 'invoice-types',
  QUYEN_HOA_DON_DIEN_TU: 'he-thong/ket-noi-hddt/quyen-hoa-don-dien-tu',
  CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO:
    'ban-hang/dieu-chinh-can-tru-cong-no/chung-tu-phai-thu-khac-chung-tu-bu-tru-cong-no',
  BANG_KE_TINH_HINH_NHAP_XUAT_DIEU_CHUYEN: 'ton-kho/tinh-hinh-nhap-xuat-kho/bang-ke-nhap-xuat-dieu-chuyen',
  // Banking related
  NGAN_HANG: 'banks',
  TAI_KHOAN_NGAN_HANG: 'bank-accounts',
  PHI_NGAN_HANG: 'bank-fees',

  // Group related
  NHOM: 'groups',
  NHOM_YEU_TO_VU_VIEC: 'case-factor-groups',
  NHOM_HOP_DONG: 'contract-groups',
  NHOM_NHA_CUNG_CAP: 'customer-groups',
  NHOM_VU_VIEC: 'case-groups',
  NHOM_KHACH_HANG: 'customer-groups',
  NHOM_DON_VI: 'unit-groups',
  NHOM_VAT_TU: 'material-groups',
  NHOM_TSCD: 'fixed-asset-groups',
  NHOM_LOAI_HD: 'contract-type-groups',
  NHOM_PHI: 'fee-groups',
  THU_CHI: 'danh-muc/ke-toan/thu-chi',

  // Address related
  DIA_CHI: 'dia-chi',
  DIA_CHI_GIAO_NHAN_HANG: 'delivery-addresses',
  DIA_CHI_NHAN_HANG: 'receiving-addresses',

  // Report related
  MAU_BAO_CAO: 'report-templates',
  DANH_MUC_MUA_BAO_CAO: 'purchase-report-categories',

  // Company information
  THONG_TIN_DOANH_NGHIEP: 'company-information',

  // Price related
  LOAI_GIA_BAN: 'sales-price-types',
  GIA_BAN: 'danh-muc/ban-hang/gia-ban',
  GIA_MUA: 'purchase-prices',

  // Position related
  VI_TRI: 'positions',
  VI_TRI_KHO_HANG: 'warehouse-locations',

  // Budget related
  CHI_TIEU_NGAN_SACH: 'ngan-sach/chi-tieu-ngan-sach',
  CHI_TIEU_NGAN_SACH_CHI_TIET: 'budget-expense-details',
  CAP_NHAT_NGAN_SACH: 'ngan-sach/cap-nhat-ngan-sach',
  CHI_TIET_CAP_NHAT_NGAN_SACH: 'ngan-sach/chi-tiet-cap-nhat-ngan-sach',

  // Payment request update related
  CAP_NHAT_DE_NGHI_THANH_TOAN: 'tien-mat/de-nghi-thanh-toan/cap-nhat-de-nghi-thanh-toan',
  CHI_TIET_CAP_NHAT_DE_NGHI_THANH_TOAN: 'tien-mat/de-nghi-thanh-toan/chi-tiet-cap-nhat-de-nghi-thanh-toan',

  // Factor related
  LOAI_YEU_TO: 'factor-types',
  YEU_TO: 'gia-thanh/danh-muc/yeu-to',

  // Asset related
  LOAI_TAI_SAN_CONG_CU: 'danh-muc/tai-san-va-cong-cu/loai-tai-san-cong-cu',
  LOAI_TSCD_CCDC: 'danh-muc/tai-san-va-cong-cu/loai-tai-san-cong-cu',
  LY_DO_TANG_GIAM_TSCD: 'danh-muc/tai-san-va-cong-cu/ly-do-tang-giam-tai-san-co-dinh',
  BO_PHAN_SU_DUNG_TSCD: 'danh-muc/tai-san-va-cong-cu/bo-phan-su-dung-ts',
  LY_DO_TANG_GIAM_CCDC: 'danh-muc/tai-san-va-cong-cu/ly-do-tang-giam-ccdc',
  BO_PHAN_SU_DUNG_CCDC: 'danh-muc/tai-san-va-cong-cu/bo-phan-su-dung-ccdc',
  KHAI_BAO_THOI_KHAU_HAO_TSCD: 'tai-san/dung-khau-hao-tscd/khai-bao-thoi-khau-hao-tscd',
  KHAI_BAO_THONG_TIN_TSCD: 'tai-san/khai-bao-tang-giam-tscd/khai-bao-thong-tin-tai-san-co-dinh',
  DIEU_CHINH_GIA_TRI_TSCD: 'tai-san/khai-bao-tang-giam-tscd/dieu-chinh-gia-tri-tscd',
  DIEU_CHUYEN_BO_PHAN_SU_DUNG_TSCD: 'tai-san/dieu-chuyen-tscd/dieu-chuyen-bo-phan-su-dung-tscd',
  HE_SO_PHAN_BO_TSCD: 'tai-san/tinh-khau-hao-tscd/khai-bao-he-so-phan-bo-tscd',
  KHAI_BAO_TAM_DUNG_KHAU_HAO_TSCD: 'tai-san/dung-khau-hao-tscd/khai-bao-tam-dung-khau-hao-tscd',
  BANG_KE_TSCD_HET_KHAU_HAO_CON_SU_DUNG: 'tai-san/tang-giam-tscd/bang-ke-tscd-het-khau-hao-con-su-dung',
  TINH_KHAU_HAO_VA_HACH_TOAN_TSCD:
    'tai-san/tinh-khau-hao-tscd/tinh-khau-hao-va-hach-toan-tai-san-co-dinh/tinh-khau-hao-va-hach-toan',
  BUT_TOAN_KHAU_HAO_TSCD:
    'tai-san/tinh-khau-hao-tscd/tinh-khau-hao-va-hach-toan-tai-san-co-dinh/but-toan-khau-hao-tscd',
  CHI_PHI_KHAU_HAO_TSCD: 'tai-san/chi-phi-khau-hao-tscd',
  BANG_TINH_KHAU_HAO_TSCD_THEO_THANG: 'tai-san/phan-bo-tscd/bang-tinh-phan-bo-tscd-theo-thang',

  // CCDC (Tool) related
  CONG_CU_DUNG_CU: 'cong-cu/khai-bao-tang-giam-ccdc/khai-bao-thong-tin-ccdc',
  KHAI_BAO_THONG_TIN_CCDC: 'cong-cu/khai-bao-tang-giam-ccdc/khai-bao-thong-tin-ccdc',
  KHAI_BAO_THOI_PHAN_BO_CCDC: 'cong-cu/dung-phan-bo-ccdc/khai-bao-thoi-phan-bo-ccdc',
  DIEU_CHINH_BO_PHAN_SU_DUNG_CCDC: 'cong-cu/dieu-chuyen-ccdc/dieu-chinh-bo-phan-su-dung-ccdc',
  HE_SO_PHAN_BO_CCDC: 'cong-cu/phan-bo-ccdc/khai-bao-he-so-phan-bo-ccdc',
  DIEU_CHINH_GIA_TRI_CCDC: 'cong-cu/khai-bao-tang-giam-ccdc/dieu-chinh-gia-tri-ccdc',
  PHAN_BO_CHI_PHI_VA_HACH_TOAN_CCDC:
    'cong-cu/phan-bo-ccdc/phan-bo-chi-phi-va-hach-toan-ccdc/phan-bo-chi-phi-va-hach-toan',
  BUT_TOAN_PHAN_BO_CCDC: 'cong-cu/phan-bo-ccdc/phan-bo-chi-phi-va-hach-toan-ccdc/but-toan-phan-bo-ccdc',
  CHI_PHI_PHAN_BO_CCDC: 'cong-cu/phan-bo-ccdc/chi-phi-phan-bo-ccdc',
  BANG_TINH_PHAN_BO_CCDC_THEO_THANG: 'cong-cu/phan-bo-ccdc/bang-tinh-phan-bo-ccdc-theo-thang',
  BAO_CAO_LUU_CHUYEN_TIEN_TE_TRUC_TIEP: 'tong-hop/bao-cao-tai-chinh/bao-cao-luu-chuyen-tien-truc-tiep',

  // Production related
  DINH_MUC_NGUYEN_VAT_LIEU: 'gia-thanh/dinh-muc-nguyen-vat-lieu',
  BANG_DINH_MUC_NGUYEN_VAT_LIEU: 'gia-thanh/bao-cao/bang-dinh-muc-nvl',
  CHI_TIET_DINH_MUC_NGUYEN_VAT_LIEU: 'gia-thanh/chi-tiet-dinh-muc-nguyen-vat-lieu',
  KHAI_BAO_VAT_TU_THAY_THE: 'gia-thanh/khai-bao/khai-bao-vat-tu-thay-the',

  // Unit conversion
  QUY_DOI_DON_VI_CHUNG: 'danh-muc/khai-bao-kho-vat-tu/quy-doi-don-vi-tinh-chung',
  QUY_DOI_DON_VI_TINH_CHI_TIET: 'danh-muc/khai-bao-kho-vat-tu/quy-doi-don-vi-tinh-chi-tiet',

  // E-invoice related
  TAI_KHOAN_HOA_DON_DIEN_TU: 'he-thong/ket-noi-hddt/tai-khoan-hoa-don-dien-tu',
  KHAI_BAO_TAI_KHOAN_HDDT: 'he-thong/ket-noi-hddt/khai-bao-su-dung-tkhddt',

  // Case related
  VU_VIEC: 'cases',

  // Import/Export related
  DANH_MUC_NHAP_XUAT: 'import-export-categories',
  LY_DO_NHAP_XUAT: 'import-exports',

  // Order source
  DANH_MUC_NGUON_DON: 'order-sources',

  NGUOI_SU_DUNG: 'users',
  NHAP_TU_DONG_THANH_PHAM_TU_HOA_DON: 'ton-kho/nhap-tu-dong-thanh-pham-tu-hoa-don/xu-ly',
  XUAT_TU_DONG_NGUYEN_VAT_LIEU: 'ton-kho/tao-phieu-xuat-nvl-tu-dong/xu-ly',
  THE_GIA_THANH_SAN_PHAM: 'gia-thanh/bao-cao/the-gia-thanh-san-pham',
  MA_GIAO_DICH: 'he-thong/chung-tu/giao-dich/by-ma-ct',
  GIAO_DICH: 'he-thong/chung-tu/giao-dich',

  // Base unit
  DON_VI_CO_SO: 'base-units',
  DON_VI: 'entity-units',

  // Production related
  LENH_SAN_XUAT: 'gia-thanh/lenh-san-xuat',

  // Invoice related
  HOA_DON: 'invoices',
  HOA_DON_MUA_HANG_TRONG_NUOC: 'mua-hang/hoa-don-mua-vao/hoa-don-mua-hang-trong-nuoc',
  HOA_DON_MUA_DICH_VU: 'mua-hang/hoa-don-mua-vao/hoa-don-mua-dich-vu',
  HOA_DON_BAN_HANG: 'ban-hang/hoa-don-ban-ra/hoa-don-ban-hang',
  HOA_DON_BAN_HANG_DICH_VU: 'service-sales-invoices',
  HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA:
    'ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-giam-gia/hoa-don-dich-vu-tra-lai-giam-gia',
  HOA_DON_DIEU_CHINH_GIA_HANG_BAN: 'ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dieu-chinh-gia-hang-ban',
  HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP: 'mua-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-nha-cung-cap',
  CHUNG_TU_PHAI_TRA_KHAC: 'mua-hang/dieu-chinh-can-tru-cong-no/chung-tu-phai-tra-khac-chung-tu-bu-tru-cong-no',
  BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH: 'mua-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no',
  DIEU_CHINH_THONG_TIN_HOA_DON: 'invoice-information-adjustments',
  HOA_DON_DIEU_CHINH_THONG_TIN: 'ban-hang/hoa-don-dien-tu/hoa-don-dieu-chinh-thong-tin',
  HOA_DON_BAN_HANG_IPOS: 'ban-hang/hoa-don-ban-hang-ipos',
  HOA_DON_BAN_DICH_VU: 'ban-hang/hoa-don-ban-ra/hoa-don-ban-dich-vu',
  HOA_DON_THEO_KHACH_HANG: 'danh-muc/doi-tuong/khach-hang/hoa-don',
  HOA_DON_THEO_KHACH_HANG_BY_UUIDS: 'danh-muc/doi-tuong/khach-hang/hoa-don/by-uuids',
  PHAN_BO_THU_TIEN_CHO_CAC_HOA_DON: 'ban-hang/phan-bo-thu-tien-cho-cac-hoa-don',
  TAO_PHIEU_THU_TU_HOA_DON: 'tien-mat/tao-phieu-thu-tu-hoa-don/filter',
  BANG_KE_CHUNG_TU: 'tong-hop/tra-cuu/bang-ke-chung-tu',
  BANG_KE_CHUNG_TU_THEO_DOI_TUONG: 'tong-hop/tra-cuu/bang-ke-chung-tu-theo-doi-tuong',
  TONG_HOP_PHAT_SINH_THEO_DOI_TUONG: 'tong-hop/tra-cuu/tong-hop-phat-sinh-theo-doi-tuong',
  // Contract related
  KHE_UOC: 'danh-muc/hop-dong-khe-uoc/khe-uoc',
  HOP_DONG: 'contracts',

  // Currency related
  NGOAI_TE: 'danh-muc/ke-toan/ngoai-te',
  TY_GIA_QUY_DOI_NGOAI_TE: 'exchange-rates',

  // Expense related
  CHI_PHI: 'expenses',
  CHI_PHI_KHONG_HOP_LE: 'danh-muc/ke-toan/chi-phi-khong-hop-le',
  PHIEU_NHAP_CHI_PHI_MUA_HANG: 'mua-hang/hoa-don-mua-vao/phieu-nhap-chi-phi-mua-hang',
  PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA: 'mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-dieu-chinh-gia-hang-mua',
  CHI_TIET_PHIEU_NHAP_CHI_PHI_MUA_HANG: 'chi-tiet',
  THUE_PHIEU_NHAP_CHI_PHI_MUA_HANG: 'thue',
  CHI_PHI_PHIEU_NHAP_CHI_PHI_MUA_HANG: 'chi-phi',
  CHI_PHI_CHI_TIET_PHIEU_NHAP_CHI_PHI_MUA_HANG: 'chi-phi-chi-tiet',
  PHI: 'danh-muc/ke-toan/phi',
  PHIEU_CHI: 'tien-mat/hach-toan/phieu-chi',

  // Unit related
  DON_VI_TINH: 'units',

  // Product/Material related
  KHAI_BAO_MA_HANG_IPOS: 'danh-muc/khai-bao-kho-vat-tu/khai-bao-ma-hang-ipos',
  KHAI_BAO_THONG_TIN_VAT_TU_THEO_DON_VI: 'danh-muc/khai-bao-kho-vat-tu/thong-tin-vat-tu-theo-don-vi',
  LOAI_VAT_TU: 'product-types',
  VAT_TU: 'materials',
  LO: 'lots',

  // Partner related
  NHA_CUNG_CAP: 'danh-muc/doi-tuong/khach-hang?is_vendor=true',
  KHACH_HANG: 'danh-muc/doi-tuong/khach-hang?is_customer=true',
  ALL_KHACH_HANG_NCC: 'danh-muc/doi-tuong/khach-hang',
  SO_DU_CONG_NO: 'so-cai/so-du-cong-no',
  SO_DU_TON_KHO_API: 'so-kho/so-du-ton-kho',

  // Employee related
  NHAN_VIEN: 'employees',

  // Department related
  BO_PHAN: 'departments',

  // Service related
  DICH_VU: 'services',

  // Warehouse relatedF
  KHO_HANG: 'warehouses',
  PHIEU_XUAT_KHO: 'ton-kho/xuat-kho-noi-bo/phieu-xuat-kho',
  PHIEU_NHAP_KHO: 'ton-kho/nhap-kho-noi-bo/phieu-nhap-kho',
  PHIEU_XUAT_DIEU_CHUYEN: 'ton-kho/xuat-kho-noi-bo/xuat-kho-dieu-chuyen',
  TINH_GIA_TRUNG_BINH: 'ton-kho/tinh-gia-hang-ton-kho/tinh-gia-trung-binh',

  // Order related
  DON_HANG: 'ban-hang/don-hang/don-hang',
  DON_HANG_MUA_TRONG_NUOC: 'mua-hang/don-mua-hang',
  KENH_BAN_HANG: 'danh-muc/ban-hang/kenh-ban-hang',

  // Return related
  PHIEU_NHAP_HANG_BAN_TRA_LAI: 'ban-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-hang-ban-tra-lai',
  PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP: 'mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-xuat-tra-lai-nha-cung-cap',

  // Payment related
  PHIEU_THANH_TOAN_TAM_UNG: 'mua-hang/thanh-toan-tam-ung/phieu-thanh-toan-tam-ung',

  // Accounting related
  SO_CHI_TIET_CONG_NO_THEO_KHACH_HANG: 'ban-hang/cong-no-khach-hang/so-chi-tiet-cong-no-theo-khach-hang',
  TINH_LAI_SO_DU_TUC_THOI_THEO_TAI_KHOAN: 'real-time-account-balances',
  BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO: 'ban-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no',
  TAI_KHOAN: 'accounts',
  TAI_KHOAN_ALL: 'accounts?show_child_accounts_only=false',

  // Transportation related
  PHUONG_TIEN_VAN_CHUYEN: 'shipping-methods',
  PHUONG_TIEN_GIAO_HANG: 'delivery-methods',

  // Entity related
  DON_VI_CHI_NHANH: 'entity-units',

  // Store related
  TAI_KHOAN_CUA_HANG: 'store-accounts',

  // Constraint related
  RANG_BUOC_NHAP: 'input-constraints',

  // GIA_THANH MODULE
  SETTINGS: 'erp/settings',
  DANH_MUC_CONG_DOAN: 'gia-thanh/danh-muc/danh-muc-cong-doan',
  VAT_TU_CO_KHAI_BAO_DINH_MUC_NHUNG_CHUA_SAN_XUAT:
    'gia-thanh/kiem-tra-gia-thanh/vat-tu-co-khai-bao-dinh-muc-nhung-chua-san-xuat',
  DANH_MUC_YEU_TO: 'gia-thanh/danh-muc/yeu-to',
  DOI_TUONG_NHAN_PHAN_BO_CHI_PHI: 'gia-thanh/khai-bao/khai-bao-doi-tuong-nhan-phan-bo-chi-phi',
  HE_SO_PHAN_BO: 'gia-thanh/khai-bao/khai-bao-he-so-phan-bo',

  // Report related
  BAO_CAO_LAI_GOP_THEO_MAT_HANG: 'bao-cao/ban-hang/bao-cao-lai-gop-theo-mat-hang',
  BAO_CAO_LAI_GOP_THEO_CUA_HANG: 'bao-cao/ban-hang/bao-cao-lai-gop-theo-cua-hang',
  BANG_KE_HANG_BAN_BI_TRA_LAI: 'ban-hang/bao-cao-ban-hang/bang-ke-hang-ban-tra-lai',
  SO_TIEN_GUI_NGAN_HANG: 'tien-gui/so-quy/so-tien-gui-ngan-hang',
  BANG_KE_HOA_DON_MUA_HANG: 'mua-hang/bao-cao-mua-hang/bang-ke-hoa-don-mua-hang-hoa-dich-vu',
  BANG_KE_HOA_DON_BAN_HANG: 'ban-hang/bao-cao-ban-hang/bang-ke-hoa-don-ban-hang-hoa-dich-vu',
  BAO_CAO_BAN_HANG_NHOM_THEO_2_CHI_TIEU: 'ban-hang/bao-cao-ban-hang/bao-cao-ban-hang-nhom-theo-hai-chi-tieu',
  BAO_CAO_MUA_HANG_NHOM_THEO_2_CHI_TIEU: 'mua-hang/bao-cao-mua-hang/bao-cao-mua-hang-nhom-theo-hai-chi-tieu',
  BANG_TONG_HOP_HOA_DON_BAN_HANG: 'ban-hang/bao-cao-ban-hang/bang-tong-hop-hoa-don-ban-hang-hoa-dich-vu',
  BANG_KE_PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP: 'mua-hang/bao-cao-mua-hang/bang-ke-phieu-xuat-tra-lai-nha-cung-cap',
  BANG_KE_CONG_NO_THEO_HOA_DON: 'ban-hang/cong-no-hoa-don-ban/bang-ke-cong-no-theo-hoa-don',
  BANG_KE_NHAP_XUAT_KHO: 'ton-kho/tinh-hinh-nhap-xuat-kho/bang-ke-nhap-xuat-kho',
  BAO_CAO_TINH_HINH_XUAT_DIEU_CHUYEN_KHO_TRUNG_TAM: 'ton-kho/tinh-hinh-nhap-xuat-kho/xuat-dieu-chuyen-kho-trung-tam',

  PHIEU_YEU_CAU_KIEM_KE: 'ton-kho/kiem-ke/phieu-yeu-cau-kiem-ke',
  CAP_NHAT_KIEM_KE: 'ton-kho/kiem-ke/cap-nhat-kiem-ke',
  XU_LY_CHENH_LECH_SO_LIEU_KIEM_KE: 'ton-kho/kiem-ke/xu-ly-chenh-lech-so-lieu-kiem-ke/xu-ly',
  PHIEU_YEU_CAU_XUAT_KHO: 'ton-kho/xuat-kho-noi-bo/phieu-yeu-cau-xuat-kho',
  BAO_CAO_TON_KHO: 'ton-kho/bao-cao-ton-kho/bao-cao-ton-kho',
  BAO_DONG_TON_KHO_VAT_TU: 'ton-kho/bao-cao-kho-khac/bao-dong-ton-kho-vat-tu',
  BAO_CAO_KIEM_KE: 'ton-kho/kiem-ke/bao-cao-kiem-ke',
  TONG_HOP_NHAP_XUAT_TON_THEO_KHO: 'ton-kho/tong-hop-nhap-xuat-ton/tong-hop-nhap-xuat-ton-theo-kho',
  TONG_HOP_NHAP_XUAT_TON_THEO_GIAO_DICH: 'ton-kho/tong-hop-nhap-xuat-ton/tong-hop-nhap-xuat-ton-theo-giao-dich',
  BANG_CAN_DOI_KE_TOAN: 'tong-hop/bao-cao-tai-chinh/bang-can-doi-ke-toan',
  BANG_CAN_DOI_PHAT_SINH_TAI_KHOAN: 'tong-hop/bao-cao-tai-chinh/bang-can-doi-phat-sinh-tai-khoan',
  BANG_CAN_DOI_PHAT_SINH_CONG_NO: 'ban-hang/cong-no-khach-hang/bang-can-doi-phat-sinh-cong-no',
  BANG_CAN_DOI_PHAT_SINH_THEO_DOI_TUONG: 'tong-hop/tra-cuu/bang-can-doi-phat-sinh-theo-doi-tuong',
  // Cash management related
  PHIEU_THU: 'tien-mat/hach-toan/phieu-thu',
  PHIEU_THU_CHI_TIET: 'phieu-thu-chi-tiet',
  GIA_THANH_CAC_BUOC: 'ton-kho/tinh-gia-ton-kho/tinh-gia-thanh',
  GIAY_BAO_NO: 'tien-gui/hach-toan/giay-bao-no',
  GIAY_BAO_CO: 'tien-gui/hach-toan/giay-bao-co',
  BAO_CAO_SO_DU_TAI_QUY_CUA_NGAN_HANG: 'tien-gui/so-quy/bao-cao-so-du-tai-quy-cua-ngan-hang',
  SO_QUY_TIEN_MAT: 'tien-mat/so-quy/so-quy-tien-mat',

  // Accounting voucher related
  PHIEU_KE_TOAN: 'tong-hop/hach-toan/phieu-ke-toan',
  PHIEU_KE_TOAN_THEO_NGHIEP_VU: 'tong-hop/hach-toan/phieu-ke-toan-theo-nghiep-vu',
  KHAI_BAO_NGHIEP_VU_KE_TOAN: 'tong-hop/khai-bao/khai-bao-nghiep-vu-ke-toan',
  CHUNG_TU_KE_TOAN: 'journal-entries/so-ct-goc',
  BUT_TOAN_HUY: 'tong-hop/but-toan-cuoi-ky/but-toan-huy',
  BUT_TOAN_KET_CHUYEN: 'tong-hop/but-toan-cuoi-ky/but-toan-ket-chuyen-ke-toan',

  // Chữ i
  SO_CAI: 'so-cai',
  SO_NHAT_KY_CHUNG: 'tong-hop/so-ke-toan/so-nhat-ky-chung',
  SO_CAI_LEN_CHO_NHIEU_TAI_KHOAN: 'tong-hop/so-ke-toan/so-cai-len-cho-nhieu-tai-khoan',
  BAO_CAO_SO_DU_TAI_KHOAN: 'tong-hop/so-ke-toan/bao-cao-so-du-tai-khoan',
  SO_KHO: 'so-kho',
  THANH_TOAN_PHAI_TRA: 'thanh-toan-phai-tra',
  THANH_TOAN_PHAI_THU: 'thanh-toan-phai-thu',
  THUE_VAT_DAU_RA: 'thue-vat-dau-ra',
  THUE_VAT_DAU_VAO: 'thue-vat-dau-vao',
  THONG_TIN_CHUNG_TU: 'thong-tin-chung-tu',
  PHIEU_NHAP_DIEU_CHUYEN: 'ton-kho/nhap-kho-noi-bo/phieu-nhap-dieu-chuyen',

  // Báo cáo
  BAO_CAO_KET_QUA_HOAT_DONG_KINH_DOANH: 'tong-hop/bao-cao-tai-chinh/bao-cao-ket-qua-san-xuat-kinh-doanh',
  MAU_BAO_CAO_KET_QUA_HOAT_DONG_KINH_DOANH:
    'tong-hop/bao-cao-tai-chinh/mau-bao-cao-ket-qua-san-xuat-kinh-doanh/mau-bao-cao-ket-qua-san-xuat-kinh-doanh',
  CHI_TIET_MAU_BAO_CAO_KET_QUA_HOAT_DONG_KINH_DOANH:
    'tong-hop/bao-cao-tai-chinh/mau-bao-cao-ket-qua-san-xuat-kinh-doanh/chi-tiet-mau-bao-cao-ket-qua-san-xuat-kinh-doanh',
  BAO_CAO_KET_QUA_HOAT_DONG_SAN_XUAT_KINH_DOANH_NHIEU_KY:
    'tai-chinh/phan-tich-nhieu-ky-nhieu-doi-tuong/bao-cao-ket-qua-hoat-dong-san-xuat-kinh-doanh-cho-nhieu-ky',

  SO_DU_DAU_KY_HOA_DON_DAU_RA: 'tong-hop/dau-ky/so-du-dau-ky-hoa-don-dau-ra',
  SO_DU_DAU_KY_HOA_DON_DAU_VAO: 'tong-hop/dau-ky/so-du-dau-ky-hoa-don-dau-vao',

  TON_KHO_DAU_KY_VAT_TU_SAN_PHAM: 'tong-hop/dau-ky/ton-kho-dau-ky-vat-tu-san-pham',
  CHUNG_TU_THANH_TOAN_DAU_KY_HOA_DON_DAU_VAO: 'tong-hop/dau-ky/chung-tu-thanh-toan-dau-ky-hoa-don-dau-vao',
  SO_DU_DAU_KY_TAI_KHOAN_VA_DOI_TUONG: 'tong-hop/dau-ky/so-du-dau-ky-tai-khoan-va-doi-tuong',
  SO_CAI_MOT_TAI_KHOAN: 'tong-hop/so-ke-toan/so-cai-mot-tai-khoan',
  SO_CHI_TIET_CUA_MOT_TAI_KHOAN: 'tong-hop/so-ke-toan/so-chi-tiet-cua-mot-tai-khoan',
  BAO_CAO_SO_DU_CONG_NO_BH: 'ban-hang/cong-no-khach-hang/bao-cao-so-du-cong-no',
  PHIEU_XUAT_CHENH_LECH: 'ton-kho/xuat-kho-noi-bo/phieu-xuat-chenh-lech',
  PHIEU_NHAP_CHENH_LECH: 'ton-kho/nhap-kho-noi-bo/phieu-nhap-chenh-lech',

  SO_DU_TON_KHO: 'tong-hop/tinh-lai/so-du-ton-kho',
  SO_DU_TAI_KHOAN: 'tong-hop/tinh-lai/so-du-tai-khoan',
  SO_DU_TUC_THOI_TAI_KHOAN: 'tong-hop/tinh-lai/so-du-tuc-thoi-tai-khoan',
  SO_DU_TUC_THOI_TON_KHO: 'tong-hop/tinh-lai/so-du-tuc-thoi-ton-kho',
  EXCEL: 'excel/get-uuid-by-code',
  BANG_GIA_TRUNG_BINH_THANG: 'ton-kho/bao-cao-kho-khac/bang-tinh-gia-trung-binh',

  // Permissions related
  NHOM_NGUOI_SU_DUNG: 'permissions/users',
  NHOM_NGUOI_SU_DUNG_TAI_KHOAN: 'he-thong/tai-khoan/khai-bao-nhom-nguoi-su-dung',
  KHAI_BAO_NGUOI_SU_DUNG: 'he-thong/tai-khoan/khai-bao-nguoi-su-dung',

  AUTOCOMPLETE_DATA: 'getautocompletedata'
};

// Also export as default for backward compatibility
export default QUERY_KEYS;

export const DOCUMENT_TYPES = {
  HoaDonBanHangModel: QUERY_KEYS.HOA_DON_BAN_HANG,
  HoaDonBanHangIposModel: QUERY_KEYS.HOA_DON_BAN_HANG_IPOS,
  HoaDonDichVuModel: QUERY_KEYS.HOA_DON_BAN_DICH_VU,
  PhieuNhapHangBanTraLaiModel: QUERY_KEYS.PHIEU_NHAP_HANG_BAN_TRA_LAI,
  HoaDonDichVuTraLaiGiamGiaModel: QUERY_KEYS.HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA,
  HoaDonDieuChinhGiaHangBanModel: QUERY_KEYS.HOA_DON_DIEU_CHINH_GIA_HANG_BAN,
  ChungTuPhaiThuKhacChungTuBuTruCongNoModel: QUERY_KEYS.CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO,
  ButToanDieuChinhGiamCongNoModel: QUERY_KEYS.BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO,
  HoaDonMuaHangTrongNuocModel: QUERY_KEYS.HOA_DON_MUA_HANG_TRONG_NUOC,
  HoaDonMuaDichVuModel: QUERY_KEYS.HOA_DON_MUA_DICH_VU,
  PhieuNhapChiPhiMuaHangModel: QUERY_KEYS.PHIEU_NHAP_CHI_PHI_MUA_HANG,
  PhieuThanhToanTamUngModel: QUERY_KEYS.PHIEU_THANH_TOAN_TAM_UNG,
  PhieuNhapDieuChinhGiaHangMuaModel: QUERY_KEYS.PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA,
  HoaDonDichVuTraLaiNhaCungCapModel: QUERY_KEYS.HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP,
  PhieuXuatTraLaiNhaCungCapModel: QUERY_KEYS.PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP,
  ChungTuPhaiTraKhacChungTuBuTruCongNoModel: QUERY_KEYS.CHUNG_TU_PHAI_TRA_KHAC,
  ButToanDieuChinhGiamCongNoMuaHangModel: QUERY_KEYS.BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH,
  PhieuNhapKhoModel: QUERY_KEYS.PHIEU_NHAP_KHO,
  PhieuXuatKhoModel: QUERY_KEYS.PHIEU_XUAT_KHO,
  PhieuNhapDieuChuyenModel: QUERY_KEYS.PHIEU_NHAP_DIEU_CHUYEN,
  PhieuXuatDieuChuyenModel: QUERY_KEYS.PHIEU_XUAT_DIEU_CHUYEN,
  PhieuChiModel: QUERY_KEYS.PHIEU_CHI,
  PhieuThuModel: QUERY_KEYS.PHIEU_THU,
  BankTransferDocumentModel: QUERY_KEYS.GIAY_BAO_NO,
  GiayBaoCoModel: QUERY_KEYS.GIAY_BAO_CO,
  PhieuKeToanModel: QUERY_KEYS.PHIEU_KE_TOAN,
  PhieuKeToaNghiepVuModel: QUERY_KEYS.PHIEU_KE_TOAN_THEO_NGHIEP_VU,
  ButToanKetChuyenKeToanModel: QUERY_KEYS.BUT_TOAN_KET_CHUYEN,
  ButToanHuyModel: QUERY_KEYS.BUT_TOAN_HUY
};
